"use client"

import { useEffect, useState } from "react"
import Sidebar from "./Sidebar"
import Header from "./Header"
import DashboardContent from "./dashboard-content"
import SubmitFeedback from "./submit-feedback"
import TrackFeedback from "./track-feedback"
import MyFeedback from "./my-feedback"
import EngagementManagement from "./engagement-management"
import EngagementDetails from "./engagement-details"
import UserManagement from "./user-management"

export default function Dashboard({ userType, onLogout }) {
  const [activeTab, setActiveTab] = useState("")
  const [sidebarOpen, setSidebarOpen] = useState(false)

  useEffect(() => {
    // Set initial active tab based on user type
    if (userType === "citizen") {
      setActiveTab("submit-feedback")
    } else if (userType === "agency") {
      setActiveTab("dashboard")
    }
  }, [userType])

  const renderContent = () => {
    switch (activeTab) {
      case "dashboard":
        return <DashboardContent userType={userType} />
      case "submit-feedback":
        return <SubmitFeedback />
      case "track-feedback":
        return <TrackFeedback />
      case "customer-engagement":
        return <MyFeedback />
      case "engagement-management":
        return <EngagementManagement />
      case "engagement-details":
        return <EngagementDetails userType={userType} />
      case "users":
        return <UserManagement />
      default:
        return <DashboardContent userType={userType} />
    }
  }

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        userType={userType}
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header userType={userType} onLogout={onLogout} onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 p-4 lg:p-6">{renderContent()}</main>
      </div>
    </div>
  )
}
